import type { DispenseLimitRow } from '@/utils/dosageLimit/getFormulationDispenseLimitRows';
import type { StateCreator } from 'zustand';
import type { DispenseLimitPad, PrescriptionAssistantSliceType, PrescriptionPadRules } from '../types';
import { revalidatePad } from './revalidatePad';

type SetPrescriptionAssistant = Parameters<
  StateCreator<PrescriptionAssistantSliceType, [['zustand/immer', never], ['zustand/devtools', never]], []>
>[0];

/**
 * Writes the pad re-derived by `revalidatePad`. The pad is re-derived outside the immer draft: `filters` is a Map,
 * which immer cannot draft without its MapSet plugin, so reading it inside `set` throws.
 * @param update - the action's other writes, made in the same update
 * @param derivedRows - the pad's rows when the action already derived them, so they are not derived twice
 */
export const setRevalidatedPad = (
  set: SetPrescriptionAssistant,
  pad: DispenseLimitPad,
  rules: PrescriptionPadRules,
  actionName: string,
  update?: (state: PrescriptionAssistantSliceType) => void,
  derivedRows?: DispenseLimitRow[],
) => {
  const { medicationPadItems, dispenseLimits } = revalidatePad(pad, rules, derivedRows);

  set(
    (state: PrescriptionAssistantSliceType) => {
      update?.(state);
      state.prescriptionAssistant.prescriptionPad.medicationPadItems = medicationPadItems;
      state.prescriptionAssistant.prescriptionPad.dispenseLimits = dispenseLimits;
    },
    false,
    actionName,
  );
};
